import { actionStrings } from './actions';
import { actionStrings as authActionStrings } from '../auth/actions';
import { fromJS } from 'immutable';

const initState = fromJS({});

export const reducer = (state = initState, action) => {
  switch (action.type) {
    case actionStrings.SET_FILTERS: {
      const currentFilter = state.get(action.payload.filterName) || {};

      return state.set(action.payload.filterName, {
        ...currentFilter,
        ...action.payload.parameters,
      });
    }
    case actionStrings.CLEAR_FILTER:
      return initState;
    case authActionStrings.LOGOUT:
      return initState;
    default:
      return state;
  }
};
